import { TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import { useContext } from 'react'
import { FilterTypes } from '../constants/Filter'
import { InformesContext } from '../providers/InformesProvider'
import { outlinedFilterFieldSx, standardFilterFieldSx } from '../styles/filterFieldStyles'

const DATE_FORMAT = 'YYYY-MM-DD'

/**
 * Enum for tri-state values.
 * @readonly
 * @enum {string}
 */
export const FiltersValuePosition = {
  HASTA: '_HASTA',
  DESDE: '_DESDE',
  FIJO: '',
}

/**
 *
 * @param {Object} props
 * @param {InformeFilter} props.filter
 * @param {boolean} props.validating
 * @param {boolean} props.disabled
 * @param {(newValue: any, pos: string) => void} props.changeFilter
 * @param {FiltersValuePosition} props.position
 */
export default function FiltersCustomTextField({
  filter,
  validating,
  changeFilter,
  position,
  disabled,
}) {
  const Context = useContext(InformesContext)

  const initialValue =
    position === FiltersValuePosition.FIJO
      ? filter.valor_inicial_filtro
      : position === FiltersValuePosition.DESDE
        ? filter.valor_inicial_filtro_desde
        : position === FiltersValuePosition.HASTA
          ? filter.valor_inicial_filtro_hasta
          : null

  const filterKey = `${filter.nombre_filtro}${position}`
  const storedValue = Context.active.filterData[filterKey]
  const actualValue = storedValue ? (storedValue !== '' ? storedValue : initialValue) : initialValue

  const required = filter.obligatorio === 'S'
  const error = required && validating && !storedValue
  const label = `${filter.titulo_columna} ${position.length > 0 ? position.slice(1) : position}`
  const isDate = filter.data_type === 'DATE'

  if (isDate) {
    const parsed = actualValue ? dayjs(actualValue) : null
    const dateValue = parsed && parsed.isValid() ? parsed : null

    return (
      <DatePicker
        sx={{ ...outlinedFilterFieldSx, width: '100%' }}
        label={label}
        value={dateValue}
        disabled={disabled}
        onChange={(newValue) => {
          if (!newValue) {
            changeFilter('', filterKey)
            return
          }
          if (!newValue.isValid()) return
          if (newValue.year() < 1000) return
          changeFilter(newValue.format(DATE_FORMAT), filterKey)
        }}
        slotProps={{
          textField: {
            error,
            required,
            fullWidth: true,
            InputLabelProps: { shrink: true },
          },
        }}
      />
    )
  }

  return (
    <TextField
      sx={standardFilterFieldSx}
      InputLabelProps={{ shrink: true }}
      InputProps={{ maxLength: 12 }}
      error={error}
      disabled={disabled}
      value={actualValue ?? ''}
      variant="standard"
      onChange={(e) => {
        if (parseInt(filter.longitud_maxima) >= e.target.value.length) {
          changeFilter(e.target.value, filterKey)
        }
      }}
      type={FilterTypes[filter.data_type]}
      label={label}
      required={required}
      fullWidth
    />
  )
}
